import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';

import EditButton from '../components/common/EditButton';
import StickyPageHeader from '../components/common/StickyPageHeader';
import Toggle from '../components/common/Toggle';
import CarrierDetail from '../components/panels/CarrierDetail';
import { AuthContext } from '../contexts/authContext';
import { useCarrierUpdate, useSelectedCarrier } from '../hooks/apiHooks';
import Layout from '../layout';
import { UserRole } from '../models/User';

const CarrierProfilePage = ({ routes }) => {
  const { authUser } = useContext(AuthContext);
  const { selectedCarrier } = useSelectedCarrier();
  const carrierUpdateMutation = useCarrierUpdate();
  const [showEditModal, setShowEditModal] = useState(false);

  const isAdmin = useMemo(
    () => [UserRole.SUPER_ADMIN, UserRole.ADMIN].includes(authUser.role),
    [authUser.role]
  );

  const toggleCarrierActive = React.useCallback(() => {
    if (selectedCarrier) {
      carrierUpdateMutation.mutate({
        ...selectedCarrier,
        active: !selectedCarrier.active,
      });
    }
  }, [carrierUpdateMutation, selectedCarrier]);

  const onUpdate = useCallback(
    (updated) => {
      carrierUpdateMutation.mutate(updated);
    },
    [carrierUpdateMutation]
  );

  useEffect(() => {
    if (carrierUpdateMutation.isSuccess) {
      setShowEditModal(false);
    }
  }, [carrierUpdateMutation.isSuccess]);

  return (
    <Layout
      carrierLoading={!selectedCarrier}
      menuIndex={isAdmin ? 1 : 0}
      routes={routes}
      showCarriersNavigation={isAdmin}
    >
      {selectedCarrier && (
        <>
          <StickyPageHeader
            subtitle={
              <>
                {selectedCarrier.name}
                {authUser?.role === UserRole.SUPER_ADMIN && (
                  <Toggle
                    defaultChecked={selectedCarrier.active}
                    loading={carrierUpdateMutation.isLoading}
                    size="small"
                    style={{ marginLeft: 12 }}
                    onChange={toggleCarrierActive}
                  />
                )}
                <EditButton
                  style={{ marginLeft: 12 }}
                  onClick={() => setShowEditModal(true)}
                >
                  Edit
                </EditButton>
              </>
            }
            title="Profile"
          />
          <CarrierDetail
            carrier={selectedCarrier}
            id="profile"
            showEditModal={showEditModal}
            updateMutation={carrierUpdateMutation}
            onClose={() => setShowEditModal(false)}
            onUpdate={onUpdate}
          />
        </>
      )}
    </Layout>
  );
};

export default CarrierProfilePage;
